import { Box, Card } from '@mui/material'

import { useContext, useEffect, useState } from 'react'
import WTypography from 'Components/whiteTypography'

import 'moment/locale/fr'

import { useNavigate } from 'react-router-dom'

import { useSelector } from 'react-redux'
import { deviseCal } from 'utils/helpers'
import CustomButton from 'Components/CustomButton/CustomButton'
import { makeGetRequest } from 'utils/api'
import { AppContext } from 'context'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
function MonBudgetCard({ oldData, updateReports }) {
  const { tableAccount } = useContext(AppContext)
  const siteDevise = useSelector((store) => store.devise)
  const { t } = useTranslation('layout') // LAP-733 (GE022)

  const navigate = useNavigate()
  const [reports, setReports] = useState(oldData)

  const yearData = async (yearOrDate) => {
    const { data } = await makeGetRequest(
      `/api/Finance/reports/${yearOrDate}/?calcul=${oldData.calcul}&account=${tableAccount}`,
      {},
      true,
    )
    setReports(data)
  }
  useEffect(() => {
    if (tableAccount !== '') yearData('month')
  }, [tableAccount])
  return (
    <>
      <Card className="dashboard_card__root1">
        <Box
          className="dashboard_card__header1 no-drag"
          onClick={() => {
            navigate('/Monbudget')
          }}
        >
          <WTypography component={'span'} variant="h6">
            {/* LAP-733 (GE022) — render localized title via frontend i18n keyed on
                stable `calcul`; fall back to backend `reports.nom` if the budget card
                isn't recognized. */}
            {(() => {
              if (reports?.calcul === 'budget.js') {
                const translated = t('finance.fiStatement.myBudget')
                if (translated && translated !== 'finance.fiStatement.myBudget') return translated
              }
              return reports?.nom || ''
            })()}
          </WTypography>
          <WTypography component={'span'} variant="h6">
            {deviseCal(reports?.calculation.total, siteDevise.devise.to_eur)}

            <WTypography
              component={'span'}
              sx={{ fontSize: '12px', color: 'white', marginLeft: '4px' }}
            ></WTypography>
          </WTypography>
        </Box>

        <Box minWidth={3} mb={8} height={'70%'}>
          {reports?.calculation?.data.map((el, index) => {
            // LAP-733 (GE022) — defensive client-side translation for the four
            // budget categories and their target/actual labels. The backend serves
            // these strings raw in French; this layer rewrites them when the
            // frontend recognises the canonical FR value, otherwise the backend
            // value is shown verbatim (forward-compatible with backend i18n).
            const NAME_KEY = {
              'Revenu': 'finance.fiStatement.budgetRevenu',
              'Dépense nécessaire': 'finance.fiStatement.budgetNecessary',
              'Dépense occasionnelle': 'finance.fiStatement.budgetOccasional',
              'Investissement / cashflow / Epargne': 'finance.fiStatement.budgetInvestment',
              'Investissement / cashflow / Épargne': 'finance.fiStatement.budgetInvestment',
            }
            const LABEL_KEY = {
              'Obj.': 'finance.fiStatement.budgetTargetLabel',
              'réel': 'finance.fiStatement.budgetActualLabel',
              'act.': 'finance.fiStatement.budgetActionLabel',
            }
            const localized = (raw, map) => {
              if (!raw) return raw
              const key = map[raw]
              if (!key) return raw
              const v = t(key)
              return v && v !== key ? v : raw
            }
            return (
            <Box key={index} className="progress-bar-container">
              <div style={{ color: 'gray' }}>{localized(el.name, NAME_KEY)}</div>
              <div style={{ textAlign: 'end', color: 'white' }}>
                {localized(el.cible_t, LABEL_KEY)} {deviseCal(el.cible, siteDevise.devise.to_eur)}
              </div>
              <div className="progress-bar-b">
                <div
                  className="progress-fill"
                  style={{
                    width: `${
                      (el.encours / el.cible) * 100 > 100 ? 100 : (el.encours / el.cible) * 100
                    }%`,
                    backgroundColor: el.color,
                  }}
                >
                  <div style={{ marginLeft: '5px' }}>
                    {localized(el.encours_t, LABEL_KEY)} {deviseCal(el.encours, siteDevise.devise.to_eur)}
                  </div>
                </div>
                {/* <div className="target-line" style={{ left: `${(el.target / el.cible) * 100}%` }}>
                  <div className="target-label">
                    {el.target_t} {deviseCal(el.target, siteDevise.devise.to_eur)}
                  </div>
                </div> */}
              </div>
            </Box>
          )})}
        </Box>

        <Box mt={2} className="dashboard_card__filters no-drag">
          <Box>
            <CustomButton onClick={(e) => yearData('year')} style={{ padding: 0 }}>
              {t('finance.fiStatement.year')}
            </CustomButton>
            <CustomButton onClick={(e) => yearData('month')} style={{ padding: 0 }}>
              {t('finance.fiStatement.month')}
            </CustomButton>
          </Box>
        </Box>
      </Card>
    </>
  )
}

export default MonBudgetCard
